import { render } from "./LanguageModal.vue?vue&type=template&id=0b302bc1&scoped=true"
import script from "./LanguageModal.vue?vue&type=script&lang=js"
export * from "./LanguageModal.vue?vue&type=script&lang=js"

import "./LanguageModal.vue?vue&type=style&index=0&id=0b302bc1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b302bc1"]])

export default __exports__